import { render, staticRenderFns } from "./UserTableMedia.vue?vue&type=template&id=6c9c80e2"
import script from "./UserTableMedia.vue?vue&type=script&lang=js"
export * from "./UserTableMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports